export default __webpack_public_path__ + "static/media/crypto-assets-long.4adf0238.png";